import React from "react";
import { Link } from "react-router-dom";

import "../../assets/CSS/model-loader.css";
import { Trans } from "react-i18next";

const MultistepCompletionHandler = ({
    isSubmitting,
    isSubmitted,
    prevStep,
    titles,
    content,
    successRedirect = null,
    successRedirectAction = null,
}) => {
    const renderTitle = () => {
        if (isSubmitting) {
            return titles.isSubmitting;
        } else if (isSubmitted) {
            return titles.isSubmitted;
        }
        return titles.default;
    };

    const renderBody = () => {
        if (isSubmitting) {
            return content.isSubmitting;
        } else if (isSubmitted) {
            return content.isSubmitted;
        }
        return isSubmitted.default;
    };

    const renderActionButtons = () => {
        if (successRedirectAction) {
            return (
                <button
                    className="secondary-green-btn mx-auto w-1/2"
                    disabled={isSubmitting}
                    onClick={successRedirectAction}
                >
                    <Trans i18nKey="done">Done</Trans>
                </button>
            );
        } else {
            return (
                <Link to={successRedirect}>
                    <button
                        className="secondary-green-btn mx-auto w-1/2"
                        disabled={isSubmitting}
                    >
                        <Trans i18nKey="done">Done</Trans>
                    </button>
                </Link>
            );
        }
    };

    return (
        <>
            <div className="card-table shadow">
                <div className="flex-auto px-4">
                    <form>
                        <div className="text-center">
                            {!isSubmitting &&
                                (isSubmitted ? (
                                    <img
                                        src={
                                            require("../../assets/images/success-img.png")
                                                .default
                                        }
                                        className="ml-auto mr-auto transform scale-75"
                                    />
                                ) : (
                                    <img
                                        src={
                                            require("../../assets/images/close.png")
                                                .default
                                        }
                                        className="ml-auto mr-auto transform scale-75"
                                    />
                                ))}

                            <p className="text-base font-bold mb-3">
                                {renderTitle()}
                            </p>

                            <p className="text-sm">{renderBody()}</p>
                        </div>

                        <div className="text-center mt-5">
                            {isSubmitting && (
                                <div className="meter">
                                    <span className="w-full"></span>
                                </div>
                            )}

                            {!isSubmitting &&
                                (!isSubmitted ? (
                                    <>
                                        <button
                                            className="bg-primary-orange mx-auto w-1/2"
                                            disabled={isSubmitting}
                                            onClick={prevStep}
                                        >
                                            <Trans i18nKey="goBack">
                                                Go Back
                                            </Trans>
                                        </button>
                                    </>
                                ) : (
                                    renderActionButtons()
                                ))}
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default MultistepCompletionHandler;
